import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Droplet, Music, HandHeart, Bus } from 'lucide-react';
export function SaintLuciaPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-293">
      <Header data-id="element-294" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-295">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-297">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-298" />
            Back to Home
          </a>

          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-299">
            <div className="mb-12 flex justify-center" data-id="element-300">
              <img src="https://cdn.magicpatterns.com/uploads/f93p7hGFgnSLSjPJ4odna3/Twice_Bourne_Logo-08.png" alt="Twice Bourne Holdings LTD Logo" className="max-w-md w-full h-auto" data-id="element-301" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-302">
              Twice Bourne Holdings LTD
            </h1>
            <p className="text-xl text-slate-300" data-id="element-303">
              Building prosperity in Saint Lucia through diverse ventures
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-304">
            {/* Buy Natural Honey */}
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col" data-id="element-305">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-306">
                <Droplet className="w-6 h-6" data-id="element-307" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-308">
                Buy Natural Honey Produced in Saint Lucia
              </h3>
              <p className="text-slate-300 flex-grow" data-id="element-309">
                Pure, raw honey harvested from our own apiaries in the Saint
                Lucia. Bottled with care and ready for delivery to your
                doorstep.
              </p>
            </div>

            {/* Artist Launch - Honorable Music */}
            <a href="/honorable-music" className="group bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col" data-id="element-310">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-311">
                <Music className="w-6 h-6" data-id="element-312" />
              </div>
              <div className="inline-block px-3 py-1 rounded-full bg-green-600/20 text-green-400 text-xs font-medium mb-3 self-start" data-id="element-313">
                Artist Launch
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-green-400 transition-colors" data-id="element-314">
                Honorable Music
              </h3>
              <p className="text-slate-300 flex-grow mb-4" data-id="element-315">
                New Soca Artist from Saint Lucia. Start a vibe and book a
                performance with two hit singles making waves.
              </p>
              <span className="text-sm text-green-400 font-medium" data-id="element-316">
                Explore the Artist →
              </span>
            </a>

            {/* Anse Canot Community Outreach Foundation - Coming Soon */}
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 flex flex-col opacity-70" data-id="element-317">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-318">
                <HandHeart className="w-6 h-6" data-id="element-319" />
              </div>
              <div className="inline-block px-3 py-1 rounded-full bg-slate-700/50 text-slate-400 text-xs font-medium mb-3 self-start" data-id="element-320">
                Coming Soon
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-321">
                Anse Canot Community Outreach Foundation
              </h3>
              <p className="text-slate-300 flex-grow" data-id="element-322">
                Supporting and uplifting the Anse Canot community through
                meaningful outreach programs and initiatives.
              </p>
            </div>

            {/* Scheduled Bus Route Service - Coming Soon */}
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 p-8 flex flex-col opacity-70" data-id="element-323">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-324">
                <Bus className="w-6 h-6" data-id="element-325" />
              </div>
              <div className="inline-block px-3 py-1 rounded-full bg-slate-700/50 text-slate-400 text-xs font-medium mb-3 self-start" data-id="element-326">
                Coming Soon
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-327">
                Scheduled Bus Route Service
              </h3>
              <p className="text-slate-300 flex-grow" data-id="element-328">
                Reliable transportation across Saint Lucia. Scheduled bus routes
                for daily commuters, camps, churches, schools and events.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-329" />
    </div>;
}